import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserRoleEnum } from 'src/app/common/services/auth/enums/user-role.enum';
import { StatusEnum } from 'src/app/common/utils/status-enum.models';
import { ButtonColorEnum } from 'src/app/shared/buttons/enums/button-color.enum';
import { InputTypeEnum } from 'src/app/shared/input/enums/input-type.enum';
import { MaskTypeEnum } from 'src/app/shared/input/enums/mask-type.enum';
import {
  GetClientRequest,
  GetClientsResponse,
} from '../../client/models/client.model';
import { ClientService } from '../../client/service/client.service';
import {
  GetUserResponse,
  GetUserRequest,
} from '../../user/service/models/user.service.model';
import { UserService } from '../../user/service/user.service';
import { CategoryService } from '../service/category.service';
import {
  CreateCategoryRequest,
  Keyword,
  KeywordVariation,
} from '../service/models/category.service.model';

const MAX_WORDS_TO_SHOW = 5;

@Component({
  selector: 'app-category-modal-new',
  templateUrl: './category-new.component.html',
  styleUrls: ['./category-new.component.scss'],
})
export class CategoryNewComponent implements OnInit {
  constructor(
    public formBuilder: FormBuilder,
    public categoryService: CategoryService,
    public clientService: ClientService,
    public userService: UserService,
    public router: Router,
    public toastrService: ToastrService
  ) {}

  isLoading: boolean = false;
  error: boolean = false;
  originalKeywords: Keyword[] = [];
  keywords: string[] = [];
  activeOptions: string[] = ['Ativo', 'Inativo'];
  textareaContent: string = '';
  showAllKeywords: boolean = false;
  showAllVariations: boolean = false;
  selectedKeyword: Keyword | undefined | null = null;

  sendEmailAlertOptions: string[] = ['Sim', 'Não'];
  receiversOptions: string[] = [];
  loadingReceivers: boolean = false;
  originalReceivers: GetUserResponse[] = [];
  loadingSearchReceivers: boolean = false;
  totalItemsReceivers: number = 0;
  loadingMoreReceivers: boolean = false;

  clientOptions: string[] = [];
  loadingClients: boolean = false;
  originalClients: GetClientsResponse[] = [];
  loadingSearchClients: boolean = false;
  totalItemsClients: number = 0;
  loadingMoreClients: boolean = false;

  clientsFilter = {
    pageSize: 10,
    pageNumber: 1,
    status: [StatusEnum.ATIVO],
    sortAscending: true,
    sortBy: 'Name',
  } as GetClientRequest;

  usersFilter = {
    pageSize: 10,
    pageNumber: 1,
    profiles: [UserRoleEnum.supervisor],
    sortAscending: true,
    sortBy: 'Name',
  } as GetUserRequest;

  form = this.formBuilder.group({
    name: ['', Validators.required],
    color: ['', Validators.required],
    active: ['', Validators.required],
    keyword: [''],
    variation: [''],
    client: ['', Validators.required],
    sendEmailAlert: ['', Validators.required],
    usersEmailAlert: [['']],
  });

  ButtonColorEnum = ButtonColorEnum;
  MaskTypeEnum = MaskTypeEnum;
  InputTypeEnum = InputTypeEnum;

  ngOnInit() {
    this.getClients(null);
    this.getReceivers(null);
  }

  getClients(name: string | null) {
    this.clientsFilter.pageNumber = 1;

    if (name != null) {
      this.clientsFilter.name = name;
      this.loadingSearchClients = true;
    } else this.loadingClients = true;

    this.clientService.get(this.clientsFilter).subscribe({
      next: (data) => {
        this.originalClients = data.items;
        this.clientOptions = data.items.map(
          (i) => i.name + ' | ' + i.cnpj
        );
        this.totalItemsClients = data.totalItems;
        this.loadingClients = false;
        this.loadingSearchClients = false;
      },
      error: () => {
        this.toastrService.error('Não foi possível carregar os Clientes.');
        this.loadingClients = false;
        this.loadingSearchClients = false;
      },
    });
  }

  getMoreClients() {
    if (this.totalItemsClients != this.clientOptions.length) {
      this.loadingMoreClients = true;
      if (this.clientsFilter.pageNumber) this.clientsFilter.pageNumber += 1;

      this.clientService.get(this.clientsFilter).subscribe({
        next: (data) => {
          this.originalClients = this.originalClients.concat(data.items);
          this.totalItemsClients = data.totalItems;

          this.clientOptions = this.clientOptions.concat(
            data.items.map((i) => i.name + ' | ' + i.cnpj)
          );

          this.loadingMoreClients = false;
        },
        error: () => {
          this.toastrService.error('Não foi possível carregar os Clientes.');
          this.loadingMoreClients = false;
        },
      });
    }
  }

  getReceivers(name: string | null) {
    this.usersFilter.pageNumber = 1;

    if (name != null) {
      this.usersFilter.name = name;
      this.loadingSearchReceivers = true;
    } else this.loadingReceivers = true;

    this.userService.get(this.usersFilter).subscribe({
      next: (data) => {
        this.originalReceivers = data.items;
        this.receiversOptions = data.items.map((i) => i.name);
        this.totalItemsReceivers = data.totalItems;
        this.loadingReceivers = false;
        this.loadingSearchReceivers = false;
      },
      error: () => {
        this.toastrService.error(
          'Não foi possível carregar a lista de recebimento.'
        );
        this.loadingReceivers = false;
        this.loadingSearchReceivers = false;
      },
    });
  }

  getMoreReceivers() {
    if (this.totalItemsReceivers != this.receiversOptions.length) {
      this.loadingMoreReceivers = true;
      if (this.usersFilter.pageNumber) this.usersFilter.pageNumber += 1;

      this.userService.get(this.usersFilter).subscribe({
        next: (data) => {
          this.originalReceivers = this.originalReceivers.concat(data.items);
          this.totalItemsReceivers = data.totalItems;

          this.receiversOptions = this.receiversOptions.concat(
            data.items.map((i) => i.name)
          );

          this.loadingMoreReceivers = false;
        },
        error: () => {
          this.toastrService.error(
            'Não foi possível carregar a lista de recebimento.'
          );
          this.loadingMoreReceivers = false;
        },
      });
    }
  }

  isFormComplete() {
    return (
      this.form.controls.name.valid &&
      this.form.controls.active.valid &&
      this.form.controls.color.valid &&
      this.keywords.length > 0
    );
  }

  closeModal() {
    this.form.reset();
    this.router.navigate(['/category/']);
  }

  addKeyword() {
    const newKeyword = this.form.controls.keyword.value ?? '';

    var allCategoryWords = this.originalKeywords
      .map((k) => k.keywordVariations)
      .flat()
      .map((x) => x.name);
    allCategoryWords.push(...this.keywords);

    if (
      newKeyword.trim() !== '' &&
      !this.stringExistsInList(newKeyword, allCategoryWords)
    ) {
      this.keywords.push(newKeyword);
      this.form.controls.keyword.reset();
      this.updateKeywordTextarea();
      this.originalKeywords.push({
        name: newKeyword,
        active: true,
        keywordVariations: [],
      } as Keyword);
    }
  }

  addKeywordVariation() {
    const newVariation = this.form.controls.variation.value ?? '';

    var allCategoryWords = this.originalKeywords
      .map((k) => k.keywordVariations)
      .flat()
      .map((x) => x.name);
    allCategoryWords.push(...this.keywords);

    if (
      newVariation.trim() !== '' &&
      !this.stringExistsInList(newVariation, allCategoryWords)
    ) {
      this.selectedKeyword?.keywordVariations.push({
        name: newVariation,
        active: true,
      } as KeywordVariation);
      this.form.controls.variation.reset();
    }
  }

  normalizeString(str: string): string {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  stringExistsInList(target: string, list: string[]): boolean {
    const normalizedTarget = this.normalizeString(target);
    return list.some((item) => this.normalizeString(item) === normalizedTarget);
  }

  showSeeAllKeywordsButton(): boolean {
    return !this.showAllKeywords && this.keywords.length > MAX_WORDS_TO_SHOW;
  }

  showSeeAllVariationsButton(): boolean | null | undefined {
    return (
      !this.showAllVariations &&
      this.selectedKeyword &&
      this.selectedKeyword.keywordVariations.length > MAX_WORDS_TO_SHOW
    );
  }

  toggleShowAllKeywords(): void {
    this.showAllKeywords = !this.showAllKeywords;
  }

  toggleShowAllVariations(): void {
    this.showAllVariations = !this.showAllVariations;
  }

  visibleKeywords(): string[] {
    if (this.showAllKeywords) return this.keywords;
    else return this.keywords.slice(0, MAX_WORDS_TO_SHOW);
  }

  visibleVariations(): KeywordVariation[] | null | undefined {
    if (this.showAllVariations) return this.selectedKeyword?.keywordVariations;
    else
      return this.selectedKeyword?.keywordVariations.slice(
        0,
        MAX_WORDS_TO_SHOW
      );
  }

  updateKeywordTextarea() {
    if (this.keywords.length <= MAX_WORDS_TO_SHOW || this.showAllKeywords)
      this.textareaContent = this.keywords.join(' ');
  }

  removeKeyword(index: number) {
    var keyword = this.keywords.splice(index, 1)[0];
    this.updateKeywordTextarea();

    this.originalKeywords = this.originalKeywords.filter(
      (k) => k.name != keyword
    );

    if (keyword == this.selectedKeyword?.name) this.selectedKeyword = null;

    if (this.keywords.length <= MAX_WORDS_TO_SHOW) this.showAllKeywords = false;
  }

  removeKeywordVariation(index: number) {
    var keyword = this.originalKeywords.find(
      (keyword) => keyword.name == this.selectedKeyword?.name
    );

    keyword?.keywordVariations.splice(index, 1);
  }

  isKeywordValid() {
    var allCategoryWords = this.originalKeywords
      .map((k) => k.keywordVariations)
      .flat()
      .map((x) => x.name);
    allCategoryWords.push(...this.keywords);

    return (
      this.form.controls.keyword.valid &&
      !this.stringExistsInList(
        this.form.controls.keyword.value ?? '',
        allCategoryWords
      )
    );
  }

  isKeywordVariationValid() {
    var allCategoryWords = this.originalKeywords
      .map((k) => k.keywordVariations)
      .flat()
      .map((x) => x.name);
    allCategoryWords.push(...this.keywords);

    return (
      this.form.controls.variation.valid &&
      !this.stringExistsInList(
        this.form.controls.variation.value ?? '',
        allCategoryWords
      )
    );
  }

  createCategory() {
    if (this.isLoading) return;

    this.isLoading = true;
    this.error = false;

    var keywords = this.getKeywordsFromText(this.keywords);
    var usersId = this.getUsersIdFromText(
      this.form.controls.usersEmailAlert.value ?? []
    );

    var request = {
      name: this.form.controls.name.value ?? '',
      color: this.form.controls.color.value ?? '',
      clientId: this.getClientIdFromText(this.form.controls.client.value ?? ''),
      active: this.form.controls.active.value === 'Ativo' ? true : false,
      sendEmailAlert:
        this.form.controls.sendEmailAlert.value === 'Sim' ? true : false,
      usersEmailAlert: usersId,
      keywords: keywords,
    } as CreateCategoryRequest;

    this.categoryService.create(request).subscribe({
      next: () => {
        this.isLoading = false;
        this.toastrService.success('Categoria cadastrada com sucesso!');
        this.router.navigate(['/category']);
      },
      error: (e) => {
        this.isLoading = false;
        this.error = true;
        console.error(e);
        this.toastrService.error(
          e.error ?? 'Ocorreu um erro ao cadastrar a categoria.'
        );
      },
    });
  }

  getUsersIdFromText(users: string[]): string[] | null {
    if (!users || users.length === 0) return null;
    let usersId: string[] = [];
    users.forEach((name) => {
      let attendant = this.originalReceivers.find((i) => i.name === name);
      if (attendant) usersId.push(attendant.id);
    });

    return usersId ? usersId : null;
  }

  getKeywordsFromText(keywordTexts: string[]): Keyword[] {
    var response: Keyword[] = [];

    keywordTexts.forEach((keywordText) => {
      var keyword = this.originalKeywords.find(
        (originalKeyword) => originalKeyword.name === keywordText
      );
      if (keyword) response.push(keyword);
      else {
        var newKeywork: Keyword = {
          active: true,
          name: keywordText,
          keywordVariations: [],
        };
        response.push(newKeywork);
      }
    });

    return response;
  }

  getClientIdFromText(text: string): string {
    if (!text) return '';
    let clientName = text.split('|')[0].trim();
    let client = this.originalClients.find(
      (i) => i.name.trim() === clientName.trim()
    );
    if (client) return client.id;
    else return '';
  }

  setSelectedKeyword(keywordName: string) {
    var keyword = this.originalKeywords.find(
      (keyword) => keyword.name == keywordName
    );

    this.selectedKeyword = keyword;
  }
}
